import { z } from 'zod';

export const zLookup = () =>
  z.object({
    id: z.number(),
    label: z.string(),
  });

export const stringLookup = () =>
  z.object({
    id: z.string(),
    label: z.string(),
  });

export const zYesno = () =>
  z.object({
    id: z.string(),
    label: z.string(),
  });
